import React from 'react';
import { useMediaQuery } from '@mui/material';
import aboutus1 from '/Images/aboutus1.svg';
import aboutus2 from '/Images/aboutus2.svg';
import aboutus3 from '/Images/aboutus3.svg';

const ThreeCards = () => {
  const isMobile = useMediaQuery('(max-width: 767px)');

  const styles = {
    container: {
      display: 'flex',
      flexDirection: isMobile ? 'column' : 'row', // Stacked layout on mobile
      justifyContent: 'center',
      alignItems: 'center',
      gap: isMobile ? '20px' : '30px',
      padding: isMobile ? '20px' : '50px',
      backgroundColor: '#E8E4E1',
    },
    card: {
      width: '100%',
      maxWidth: isMobile ? '100%' : '402px', // Full width on mobile
      minHeight: isMobile ? 'auto' : '342px', // Auto height on mobile
      padding: '30px',
      paddingTop: '60px',
      borderRadius: '10px',
      boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)',
      backgroundColor: '#E8E4E1',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      textAlign: 'center',
      overflow: 'hidden',
    },
    icon: {
      width: '80px',
      height: '80px',
      marginBottom: '20px',
    },
    title: {
      fontSize: isMobile ? '18px' : '22px', // Smaller font on mobile
      fontWeight: '600',
      color: '#2D2D2D',
      marginBottom: '10px',
    },
    description: {
      fontSize: isMobile ? '0.875rem' : '1rem', // Smaller font on mobile
      color: '#6D6D6D',
      lineHeight: '1.5',
      maxWidth: isMobile ? '100%' : '300px',
    },
  };

  const cardsData = [
    {
      icon: aboutus1,
      title: 'Security',
      description: 'We adopted a security-first approach across over wallet and custody solutions.',
    },
    {
      icon: aboutus2,
      title: 'Support',
      description: 'We offer a bespoke service and onboarding experience with expert-led concierge establishment.',
    },
    {
      icon: aboutus3,
      title: 'Scalability',
      description: 'We provide innovation-oriented solutions that help add scalability for protocols explicitly.',
    },
  ];

  return (
    <div style={styles.container}>
      {cardsData.map((card, index) => (
        <div key={index} style={styles.card}>
          <img src={card.icon} alt={card.title} style={styles.icon} />
          <h3 style={styles.title}>{card.title}</h3>
          <p style={styles.description}>{card.description}</p>
        </div>
      ))}
    </div>
  );
};

export default ThreeCards;
